import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Damaged {
  pestsDamaged?: BooleanFormType;
}

interface Props<T extends Damaged = Damaged> {
  formProps: FormikProps<T>;
  label: string;
  product: INSURANCE_NAME_VALUE;
}

export const DamagedFromPests = ({
  formProps,
  label,
  product,
}: Props): React.ReactElement | null => {
  if (
    !isDefined(formProps.values.pestsDamaged) &&
    product == INSURANCE_NAME_VALUE.HOUSE
  ) {
    return null;
  }

  return (
    <RadioButtonTrueFalse
      direction="vertical"
      name="pestsDamaged"
      id="pestsDamaged"
      label={label}
      error={getError("pestsDamaged", formProps)}
      options={getYesOrNoOptions("yes", "no")}
    />
  );
};
